import { UITypes } from "types"

import TabsWrapper from "components/common/TabsWrapper"

interface DeviceTabsProps {
  devices: UITypes.Device[] | undefined
  currentDevice: number
  className?: string
  onTabChange: (index: number) => void
}

export const DeviceTabs = ({ devices, currentDevice, onTabChange, className }: DeviceTabsProps) => {
  return (
    <TabsWrapper
      tabs={
        devices?.map((device, index) => ({
          id: device.id,
          label: device.deviceName || `Device ${index + 1}`,
          online: device.workStatus === "online",
        })) || []
      }
      currentTab={currentDevice}
      onTabChange={onTabChange}
      showActive={devices ? devices.length > 1 : false}
      className={className}
    />
  )
}
